module.exports = __webpack_public_path__ + "img/lucky_lottery@2x.7194ceaf.png";